import React from "react";
import { useLanguage } from "hooks";
import { Icons } from "components";

function SearchForm({ onSubmit }) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [keyword, setKeyword] = React.useState("");

  const handleOnSubmit = (e) => {
    e.preventDefault();
    onSubmit(keyword);
  };

  return (
    <form
      onSubmit={handleOnSubmit}
      className="search_form d-flex align-items-center position-relative mx-auto"
    >
      <input
        className="bg-light text-light5 rounded-3"
        type="text"
        placeholder={language.whatYouSearch}
        onChange={(e) => setKeyword(e.target.value)}
        value={keyword}
      />
      <button
        type="submit"
        className="filter_hover d-flex justify-content-center align-items-center bg-secondary position-absolute border-0 rounded-circle"
      >
        <Icons.Search fill="#fff" />
      </button>
    </form>
  );
}

export default SearchForm;
